import cx from 'classnames'
import './Icon.scss'

const Icon = ({ name, className, onClick, disable, ...props }) => {
    return (
        <img
            className={cx(`icon icon-${name}`, disable && 'disable', className)}
            src={`images/icons/${name}.svg`}
            alt={name}
            onClick={onClick}
            {...props}
        />
    )
}

export default Icon
